import { Box, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Maybe } from '@ts/operations'
import React from 'react'

import { Body2, H4 } from '../utils/typography'

const useStyles = makeStyles(() => ({
  image: {
    boxShadow: '0 5px 10px 0 rgba(0,0,0,0.2)',
    margin: '5% auto -12%',
    width: '75%',
  },
}))

export type OverviewPanelProps = {
  altImageText?: Maybe<string>
  description?: Maybe<string>
  imageUrl?: Maybe<string>
  title?: Maybe<string>
}

const OverviewPanel = ({ altImageText, description, imageUrl, title }: OverviewPanelProps) => {
  const classes = useStyles()

  return (
    <Paper elevation={0}>
      {(title || description) && (
        <Box pl={4} pr={2} pt={4}>
          {title && <H4 mb={1}>{title}</H4>}
          {description && <Body2 mb={1}>{description}</Body2>}
        </Box>
      )}
      {imageUrl && (
        <Box display="flex" justifyContent="center">
          <img
            alt={altImageText || 'overview panel image'}
            className={classes.image}
            src={imageUrl}
          />
        </Box>
      )}
    </Paper>
  )
}

export default OverviewPanel
